package one.healthium.bland

import co.touchlab.kermit.Logger
import co.touchlab.kermit.platformLogWriter
import one.healthium.bland.di.initKoin
import one.healthium.intercom.IntercomPlatform
import one.primehealth.analytics.AppAnalyticsPlatform
import one.primehealth.app.BaseAppConfig
import one.primehealth.app.Flavour

actual object AppInit {
    fun init(flavour: Flavour) {
        setupLogger(flavour)

        val koinApplication = initKoin(
            flavour = flavour
        )
        val baseAppConfig = koinApplication.koin.get<BaseAppConfig>()
        IntercomPlatform.init(baseAppConfig)
        koinApplication.koin.get<AppAnalyticsPlatform>() // create instance
    }

    private fun setupLogger(flavour: Flavour) {
        if (flavour == Flavour.Stage) {
            Logger.setLogWriters(platformLogWriter())
        }
    }
}